import { createFileRoute, Navigate } from '@tanstack/react-router'
import DataManagement from '@/pages/DataManagement'
import { useFeatureFlag } from '@/components/providers/FeatureFlagsProvider/useFeatureFlag'

export const Route = createFileRoute('/_layout/data-management')({
    component: RouteComponent,
})

function RouteComponent() {
    const isDataManagementEnabled = useFeatureFlag('dataManagement')

    if (!isDataManagementEnabled) {
        return <Navigate to="/dashboard" />
    }

    return <DataManagement />
}
